import apiRequestService from '@/commonProject/service/apiRequestService';

export default class setupAgreeRepository {
    /**
     * ユーザー同意済規定一覧取得APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async getUserAgreementListActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrreglst', requestBody, idToken);
        return result;
    }

    /**
     * ユーザー利用規定同意登録APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async postUserAgreementUpdateActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrregupd', requestBody, idToken);
        return result;
    }
}
